import React, { useState } from 'react'
import { message } from 'antd'
import TransfersTable from './TransfersTable'
import TransfersDrawer from './TransfersDrawer'
import InventoryTabsHeader from '../InventoryTabsHeader'
import InventoryTabsContent from '../InventoryTabsContent'
import inventorySrc from '../../inventorySrc'

function TransfersTab(props) {
  const [showDrawer, setShowDrawer] = useState(false)
  const [loading, setLoading] = useState(false)
  const [fetchData, setFetchData] = useState(true)
  const [searchText, setSearchText] = useState('')

  const onSearch = searchText => {
    setSearchText(searchText)
  }

  const saveNewTransfer = data => {
    setFetchData(false)
    setLoading(true)
    inventorySrc
      .storeTransfer(data)
      .then(response => {
        if (response.errors && Object.keys(response.errors).length > 0) {
          Object.keys(response.errors).forEach(e => message.error(response.errors[e][0].replace(/(?:presentations?)[^\s]+/, 'No. Unidades')))
          setLoading(false)
        } else {
          message.success('Información creada.')
          setShowDrawer(false)
          setLoading(false)
          setFetchData(true)
        }
      })
      .catch(err => {
        console.log(err)
        message.error('Error al guardar la compra')
        setLoading(false)
      })
  }

  return (
    <div>
      <InventoryTabsHeader
        shopsList={props.shopsList}
        selectedOption={props.selectedOption}
        setSelectedOption={option => {
          props.setSelectedOption(option)
        }}
        onSearch={onSearch}
        buttonLabel={'Nueva transferencia'}
        buttonHandler={() => {
          setShowDrawer(true)
        }}
        createPermissions={34}
        keyTab={props.keyTab}
      />
      <InventoryTabsContent
        fetchData={fetchData}
        loading={loading}
        component={TransfersTable}
        selectedOption={props.selectedOption}
        searchText={searchText}
        keyTab={props.keyTab}
      />
      <TransfersDrawer
        shopsList={props.shopsList}
        closable={(data, request) => {
          if (request === 'save') return saveNewTransfer(data)
          setShowDrawer(false)
        }}
        visible={showDrawer}
        loading={loading}
      />
    </div>
  )
}

export default TransfersTab

TransfersTab.defaultProps = {
  selectedOption: null,
  shopsList: [],
}
